import { datadogRum } from "@datadog/browser-rum";

const initDatadog = () => {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: import.meta.env.VITE_DATADOG_DASHBOARD_RUM_SERVICE_NAME,
    env: import.meta.env.VITE_ENV,
    version: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "allow"
  });

  datadogRum.startSessionReplayRecording();
};

export default initDatadog;
